import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { getFuturePortCalls } from '@api';

export function useFutureScheduleAvailability({ imoList, segmentId, entityId, setIsAvailable }) {
  const futurePortCallsQuery = useQuery({
    queryKey: [
      'oprFuturePortCalls',
      {
        Imos: imoList,
        SegmentTypeId: segmentId,
        Start: moment().utc().startOf('day')
      }
    ],
    enabled: !!entityId && !!segmentId && imoList.length > 0,
    placeholderData: [],
    queryFn: ({ signal, queryKey }) => getFuturePortCalls(queryKey[1], signal).catch(() => [])
  });

  useEffect(() => {
    if (imoList.length === 0) {
      setIsAvailable(false);
    }
    if (futurePortCallsQuery.isFetched) {
      const hasDataFuture = futurePortCallsQuery.data.length > 0;
      setIsAvailable(hasDataFuture);
    }
  }, [futurePortCallsQuery.isFetched, futurePortCallsQuery.data, setIsAvailable]);

  return futurePortCallsQuery;
}
